namespace GeniuzPOS.Inventory {
    export interface IcStockEomProcessingRow {
        Id?: number;
        MonthProcess?: string;
        YearProcess?: string;
        StartDate?: string;
        EndDate?: string;
        PostSequenceFg?: PostSequenceFgstatus;
        PostFg?: BacPostFgStatus;
        TranCount?: number;
        SkuCount?: number;
        QtyCount?: number;
        CostCount?: number;
        StartId?: number;
        EndId?: number;
        LineNoProcess?: number;
        UseFg?: number;
        LastMonthEomId?: number;
        CreateBy?: string;
        CreateDate?: string;
        FinishDate?: string;
    }

    export namespace IcStockEomProcessingRow {
        export const idProperty = 'Id';
        export const nameProperty = 'MonthProcess';
        export const localTextPrefix = 'Inventory.IcStockEomProcessing';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            MonthProcess = "MonthProcess",
            YearProcess = "YearProcess",
            StartDate = "StartDate",
            EndDate = "EndDate",
            PostSequenceFg = "PostSequenceFg",
            PostFg = "PostFg",
            TranCount = "TranCount",
            SkuCount = "SkuCount",
            QtyCount = "QtyCount",
            CostCount = "CostCount",
            StartId = "StartId",
            EndId = "EndId",
            LineNoProcess = "LineNoProcess",
            UseFg = "UseFg",
            LastMonthEomId = "LastMonthEomId",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            FinishDate = "FinishDate"
        }
    }
}
